import React from 'react';
import {Dialog, DialogTitle, DialogContent, DialogContentText, Typography, Paper, Button, Popover, Stack, TextField, DialogActions } from '@mui/material';
import '../SpeedDial.css';

export default function EditBoardMenu({
    boards,
    openTitle,
    openDescription,
    anchorElTitle,
    anchorElDescription,
    handleClickTitle,
    handleClickDescription,
    handleCloseTitle,
    handleCloseDescription,
    handleTitleSubmit,
    handleDescriptionSubmit,
    setTitle,
    setDescription,
    handleEditBoardDialogClose
}) {
    return (
        <div>
            <Dialog
                open={true}
                onClose={handleEditBoardDialogClose}
                maxWidth="xs"
                fullWidth
                BackdropProps={{
                    sx: {
                        backdropFilter: 'blur(5px)',
                        backgroundColor: 'rgba(0,0,0,0.3)',
                    }
                }}
                PaperProps={{
                    sx: {
                        width: '600px',
                        m: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                    }
                }}
            >
            <DialogTitle className='text-navbar-options' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '23px', fontWeight: '700' }} id="help-dialog-title">Editar Quadro</DialogTitle>
            <DialogContent>
                <DialogContentText id="help-dialog-description" className='text-navbar-options'>
                    <div>
                        <Typography style={{ fontSize: '17px', marginBottom: '15px', marginLeft: '2px' }} gutterBottom>Edite as informações do quadro atual:</Typography>
                        {boards.map((board) => (
                            <div
                                key={board.board_id}
                                style={{ position: 'relative', maxWidth: '100%', display: 'flex', gap: '15px' }}
                            >
                                <div style={{ display: 'flex', gap: '15px', width: '100%' }}>
                                       <div style={{ marginTop: '10px' }}>
                                        <Typography style={{ color: '#009373', overflowWrap: 'break-word', maxWidth: '220px', fontSize: '15px' }}>Título:</Typography>
                                        <Typography style={{ overflowWrap: 'break-word', maxWidth: '220px', fontSize: '17px' }}>{board.board_name}</Typography>
                                        <Typography style={{ color: '#009373', overflowWrap: 'break-word', maxWidth: '220px', fontSize: '15px' }}>Descrição:</Typography>
                                        <Typography style={{ overflowWrap: 'break-word', maxWidth: '220px', fontSize: '17px' }}>{board.board_description}</Typography>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginLeft: '50px' }}>
                                        <Button
                                            onClick={handleClickTitle}
                                            style={{ textTransform: 'none', border: 'none', borderRadius: '6px', padding: '10px', cursor: 'pointer', height: '30px', fontSize: '13px' }}
                                            className='button-edit-options'
                                        >
                                            Editar título
                                        </Button>
                                        <Button
                                            onClick={handleClickDescription}
                                            style={{ textTransform: 'none', border: 'none', borderRadius: '6px', padding: '10px', cursor: 'pointer', height: '30px', fontSize: '13px' }}
                                            className='button-edit-options'
                                        >
                                            Editar descrição
                                        </Button>                                        
                                    </div>
                                    <Popover
                                        open={openTitle}
                                        anchorEl={anchorElTitle}
                                        onClose={handleCloseTitle}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center',
                                        }}
                                    >
                                        <Stack spacing={2} padding={2} className='account-dialog'>
                                            <TextField
                                                fullWidth
                                                label="Novo título"
                                                variant="outlined"
                                                onChange={(e) => setTitle(e.target.value)}
                                                sx={{ mt: 2, mb: 2 }}
                                                InputLabelProps={{
                                                    className: 'text-field-label',
                                                }}
                                                InputProps={{
                                                    className: 'text-field-input',
                                                }}
                                            />
                                            <Button
                                                onClick={() => { handleTitleSubmit(); }}
                                                style={{ textTransform: 'none', border: 'none', borderRadius: '6px', padding: '10px', width: '100%', cursor: 'pointer', height: '40px', fontSize: '15px' }}
                                                className='button-save-options'
                                            >
                                                Salvar alteração
                                            </Button>
                                        </Stack>
                                    </Popover>

                                    <Popover
                                        open={openDescription}
                                        anchorEl={anchorElDescription}
                                        onClose={handleCloseDescription}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center',
                                        }}
                                    >
                                        <Stack className='account-dialog' spacing={2} padding={2}>
                                            <TextField
                                                fullWidth
                                                label="Nova descrição"
                                                variant="outlined"
                                                onChange={(e) => setDescription(e.target.value)}
                                                sx={{ mt: 2, mb: 2 }}
                                                InputLabelProps={{
                                                    className: 'text-field-label',
                                                }}
                                                InputProps={{
                                                    className: 'text-field-input',
                                                }}
                                            />
                                            <Button
                                                onClick={() => { handleDescriptionSubmit(); }}
                                                style={{ textTransform: 'none', border: 'none', borderRadius: '6px', padding: '10px', width: '100%', cursor: 'pointer', height: '40px', fontSize: '15px' }}
                                                className='button-save-options'
                                            >
                                                Salvar alteração
                                            </Button>
                                        </Stack>
                                    </Popover>                                  
                                </div>
                            </div>
                        ))
                        }
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleEditBoardDialogClose}
                    style={{ textTransform: 'none', border: 'none', borderRadius: '6px', padding: '10px', width: '100px', cursor: 'pointer', height: '40px' }}
                    className='button-navbar-options'
                >
                    Fechar
                </Button>
            </DialogActions>
            </Dialog>
        </div>
    );
}
